import * as React from "react";
import * as ReactDOM from "react-dom";
import { toODataString } from "@progress/kendo-data-query";
import { useDispatch, useSelector } from "react-redux";
import {
  getMattersList,
  getMattersPostings,
  getMyMattersPageList,
  fetchMatterActivities,
  fetchMatterTasks,
  fetchWorkDoneActivities,
} from "../../actions/matters.action.js";
import { searchMatter } from "../../actions/matters.action";
import { getClientsList, searchClient } from "../../actions/clients.action.js";
import {
  fetchContactsList,
  fetchContactsForCategory,
} from "services/contactsService";
import { fetchTasksList } from "services/tasksService";
import { getChitPostingList } from "../../actions/chitPosting.action.js";
import { fetchBillingRequestsList } from "services/billingRequestsService";
import {
  fetchRecordedTimeForMatter,
  fetchRecordedTime,
} from "../../services/timeService.js";
import { fetchCTOSweep } from "../../actions/ctoSweep.action";
import { debounce } from "lodash";

export const HandleGridBody = (props) => {
  const { showLoader = true } = props;
  const dispatch = useDispatch();

  const { mattersList } = useSelector((state) => state.mattersList);
  const { myMattersPageList } = useSelector((state) => state.mattersList);
  const { matterActivities } = useSelector((state) => state.mattersList);
  const { matterTasks } = useSelector((state) => state.mattersList);
  const { workDoneActivities } = useSelector((state) => state.mattersList);
  const { clientsList } = useSelector((state) => state.clients);
  const { mattersPostings } = useSelector((state) => state.mattersList);
  const { contactsList, contactsByCategory, allContacts } = useSelector(
    (state) => state.contactsList,
  );
  const { tasksList } = useSelector((state) => state.tasksList);
  const { chitPostingList } = useSelector((state) => state.chitPosting);
  const { billRequestsList } = useSelector((state) => state.billingRequests);
  const { batchPostingList } = useSelector((state) => state.chitPosting);
  const { recordedTime } = useSelector((state) => state.time);
  const { MatterRecordedTime } = useSelector((state) => state.time);
  const { ctoSweepData } = useSelector((state) => state.ctoSweep);

  const lastSuccess = React.useRef("");
  const pending = React.useRef("");

  const normalizedStatus =
    props.currentComponent === "timeRecorded-Matter"
      ? props.status?.value
      : props.status;
  // Debounced version of requestDataIfNeeded
  const debouncedRequestDataIfNeeded = React.useCallback(
    debounce(() => requestDataIfNeeded(), 250),
    [
      props.dataState,
      props.filterParameters,
      props.parameters,
      props.refresh,
      normalizedStatus,
      props.isSearched,
      props.searchValue,
      props.currentComponent,
      props?.parameter?.billsOnly,
      // props.parameter?.includeRingfenced,
      props?.parameter?.dpuWithNoVAT,
      props.updateFilter,
      props.matterId,
      props.fD,
      props.tD,
      props.categoryId,
      props.branchId,
      props.teamId,
      props.createdBy,
      props.feeEarnerRef,
      props.status,
      props.tagIds,
    ],
  );

  const requestDataIfNeeded = () => {
    if (
      pending.current ||
      toODataString(props.dataState) === lastSuccess.current
    ) {
      return;
    }

    pending.current = toODataString(props.dataState);
    let skip = props.dataState.skip / props.dataState.take + 1;
    let take = props.dataState.take;

    if (props.currentComponent === "matters" && props.searchValue) {
      const item = props.dataState.sort?.[0];

      dispatch(
        searchMatter(
          skip,
          take,
          props.searchValue,
          item,
          props.filterParameters,
          props.status,
        ),
      );
    } else if (props.currentComponent === "matters") {
      if (props.dataState.sort !== undefined) {
        const item = props.dataState.sort[0];
        dispatch(
          getMattersList(
            skip,
            take,
            item,
            props.filterParameters,
            props.status,
          ),
        );
      } else {
        dispatch(
          getMattersList(skip, take, props.filterParameters, props.status),
        );
      }
    } else if (props.currentComponent === "myMattersPage") {
      const item = props.dataState.sort[0];
      if (props.dataState.sort !== undefined) {
        dispatch(
          getMyMattersPageList(skip, take, item, props.filterParameters),
        );
      } else {
        dispatch(
          getMyMattersPageList(skip, take, undefined, props.filterParameters),
        );
      }
    } else if (
      (props.currentComponent === "clients" && !props.isSearched) ||
      (props.currentComponent === "clients" && !props.searchValue)
    ) {
      if (props.dataState.sort !== undefined) {
        const item = props.dataState.sort[0];
        dispatch(getClientsList(skip, take, item, props.filterParameters));
      } else {
        dispatch(getClientsList(skip, take, undefined, props.filterParameters));
      }
    } else if (
      props.currentComponent === "clients" &&
      props.isSearched &&
      props.searchValue
    ) {
      const item = props.dataState.sort?.[0];
      dispatch(
        searchClient(
          skip,
          take,
          props.searchValue,
          item,
          props.filterParameters,
        ),
      );
    } else if (
      props.currentComponent === "contacts" ||
      props.currentComponent === "contacts-attach"
    ) {
      const item = props.dataState.sort ? props.dataState.sort[0] : undefined;
      dispatch(
        fetchContactsList({
          page: skip,
          limit: take,
          sort: item,
          searchValue: props.searchValue,
          type: props?.type,
          active: props?.active,
          categoryId: props?.categoryId,
        }),
      );
    } else if (props.currentComponent === "attachContact") {
      dispatch(
        fetchContactsForCategory({
          categoryId: props.id,
          page: skip,
          limit: take,
          searchValue: props.searchValue,
        }),
      );
    } else if (props.currentComponent === "tasks") {
      const item = props.dataState.sort ? props.dataState.sort[0] : undefined;
      dispatch(
        fetchTasksList({
          page: skip,
          limit: take,
          sort: item,
          branchId: props.branchId,
          teamId: props.teamId,
          createdBy: props.createdBy,
          feeEarnerRef: props.feeEarnerRef,
          fD: props.fD,
          tD: props.tD,
          status: props.status,
          searchValue: props.searchValue,
        }),
      );
    }

    // timerecorded
    else if (props.currentComponent === "timeRecorded-Matter") {
      const item = props.dataState.sort?.[0];
      dispatch(
        fetchRecordedTimeForMatter({
          matterId: props.matterId,
          status: props.status,
          fD: props?.fD,
          tD: props?.tD,
          page: skip,
          limit: take,
          sort: item,
        }),
      );
    } else if (props.currentComponent === "timeRecorded") {
      dispatch(
        fetchRecordedTime({
          feeEarner: props.feeEarner,
          status: props.status,
          fD: props?.fD,
          tD: props?.tD,
          matterId: props?.matterId,
          page: skip,
          limit: take,
        }),
      );
    } else if (props.currentComponent === "caseActivities") {
      if (props.dataState.sort !== undefined) {
        const item = props.dataState.sort[0];
        dispatch(
          fetchMatterActivities(
            props.matterId,
            props.feeEarner,
            props?.fD,
            props?.tD,
            props?.typeId,
            skip,
            take,
            item,
            props.searchValue,
            props.tagIds,
          ),
        );
      } else {
        dispatch(
          fetchMatterActivities(
            props.matterId,
            props.feeEarner,
            props?.fD,
            props?.tD,
            props?.typeId,
            skip,
            take,
            props.searchValue,
            props.tagIds,
          ),
        );
      }
    } else if (props.currentComponent === "casefile-tasks") {
      if (props.dataState.sort !== undefined) {
        const item = props.dataState.sort[0];
        dispatch(
          fetchMatterTasks(
            props.matterId,
            props.completed,
            props?.fD,
            props?.tD,
            skip,
            take,
            item,
          ),
        );
      } else {
        dispatch(
          fetchMatterTasks(
            props.matterId,
            props.completed,
            props?.fD,
            props?.tD,
            skip,
            take,
          ),
        );
      }
    } else if (props.currentComponent === "workDone") {
      if (props.dataState.sort !== undefined) {
        const item = props.dataState.sort[0];
        dispatch(
          fetchWorkDoneActivities(
            props.branchId,
            props.teamId,
            props.feeEarnerRef,
            props?.fD,
            props?.tD,
            props?.typeId,
            skip,
            take,
            item,
            props.searchValue,
          ),
        );
      } else {
        dispatch(
          fetchWorkDoneActivities(
            props.branchId,
            props.teamId,
            props.feeEarnerRef,
            props?.fD,
            props?.tD,
            props?.typeId,
            skip,
            take,
            undefined,
            props.searchValue,
          ),
        );
      }
    } else if (
      props.currentComponent === "chitPosting" ||
      props.currentComponent === "batchPosting" ||
      props.currentComponent === "chitAuthorization"
    ) {
      if (props.dataState.sort !== undefined) {
        const item = props.dataState.sort[0];
        dispatch(
          getChitPostingList(
            skip,
            take,
            props.parameters,
            props.currentComponent,
            item,
          ),
        );
      } else {
        dispatch(
          getChitPostingList(
            skip,
            take,
            props.parameters,
            props.currentComponent,
            undefined,
          ),
        );
      }
    } else if (props.currentComponent === "billingRequests") {
      const item = props.dataState?.sort?.[0];
      dispatch(
        fetchBillingRequestsList({
          page: skip,
          limit: take,
          parameter: props.parameters,
          sort: item,
        }),
      );
    } else if (
      props.currentComponent === "mattersLedger" &&
      props.isSearched &&
      props.searchValue
    ) {
      dispatch(getMattersPostings(props.searchValue, "ALL"));
    } else if (props.currentComponent === "ctoSweep") {
      if (props.dataState.sort !== undefined) {
        const item = props.dataState.sort[0];
        dispatch(fetchCTOSweep(skip, take, props.parameter, item));
      } else {
        dispatch(fetchCTOSweep(skip, take, props.parameter));
      }
    }
  };
  React.useEffect(() => {
    if (mattersList && props.currentComponent === "matters") {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: mattersList.data,
          total: mattersList.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    mattersList,
    pending,
    props.dataState,
    props.filterParameters,
    props.status,
    props.refresh,
    lastSuccess,
    props.isSearched,
    props.searchValue,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (props.currentComponent !== "myMattersPage") return;
    if (myMattersPageList) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: myMattersPageList.data,
          total: myMattersPageList.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    myMattersPageList,
    props.refresh,
    props.filterParameters,
    pending,
    props.dataState,
    lastSuccess,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (props.currentComponent !== "clients") return;
    if (clientsList) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived({
          data: clientsList.data,
          total: clientsList.total,
        });

        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    clientsList,
    props.dataState,
    props.filterParameters,
    props.isSearched,
    props.searchValue,
    props.refresh,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (contactsList && props.currentComponent === "contacts") {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: contactsList.data,
          total: contactsList.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    contactsList,
    pending,
    props.dataState,
    lastSuccess,
    props.searchValue,
    props.categoryId,
    debouncedRequestDataIfNeeded,
  ]);
  // all contacts for attach contact
  React.useEffect(() => {
    if (allContacts && props.currentComponent === "contacts-attach") {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: allContacts.data,
          total: allContacts.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    allContacts,
    pending,
    props.dataState,
    lastSuccess,
    props.searchValue,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (props.currentComponent !== "tasks") return;
    if (tasksList) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: tasksList.data,
          total: tasksList.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    tasksList,
    props.dataState,
    props.branchId,
    props.teamId,
    props.createdBy,
    props.feeEarnerRef,
    props.fD,
    props.tD,
    props.status,
    props.searchValue,
    props.updateFilter,
    props.refresh,
    lastSuccess,
    pending,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (contactsByCategory && props.currentComponent === "attachContact") {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: contactsByCategory?.data,
          total: contactsByCategory?.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    contactsByCategory,
    props.id,
    pending,
    props.dataState,
    lastSuccess,
    props.searchValue,
    props.categoryState,
    debouncedRequestDataIfNeeded,
  ]);

  // time recorded

  React.useEffect(() => {
    if (
      MatterRecordedTime &&
      props.currentComponent === "timeRecorded-Matter"
    ) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (MatterRecordedTime[props?.matterId]) {
        props.onDataReceived.call(undefined, {
          data: MatterRecordedTime[props?.matterId]?.data,
          total: MatterRecordedTime[props?.matterId]?.total,
        });
        return;
      }
    }
    if (!MatterRecordedTime[props?.matterId] || props.updateFilter) {
      debouncedRequestDataIfNeeded();
    }
  }, [
    MatterRecordedTime,
    props?.updateFilter,
    props?.matterId,
    pending,
    lastSuccess,
    props.refresh,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (props.currentComponent !== "timeRecorded") {
      return;
    }
    if (recordedTime) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (
        toODataString(props.dataState) === lastSuccess.current ||
        props.isSearched
      ) {
        props.onDataReceived.call(undefined, {
          data: recordedTime?.data || recordedTime,
          total: recordedTime?.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    recordedTime,
    props.status,
    props.fD,
    props.tD,
    props.feeEarner,
    pending,
    props.dataState,
    props.matterId,
    lastSuccess,
    props.refresh,
    debouncedRequestDataIfNeeded,
  ]);

  // case activities
  React.useEffect(() => {
    if (matterActivities && props.currentComponent === "caseActivities") {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (matterActivities[props?.matterId]) {
        props.onDataReceived.call(undefined, {
          data: matterActivities[props?.matterId]?.data,
          total: matterActivities[props?.matterId]?.total,
        });
        return;
      }
    }
    // if (!matterActivities[props?.matterId] || props.updateFilter) {
    //   debouncedRequestDataIfNeeded();
    // }
  }, [
    props?.updateFilter,
    props.searchValue,
    matterActivities,
    props?.matterId,
    pending,
    props.dataState,
    lastSuccess,
    props.refresh,
    // debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (props.currentComponent !== "casefile-tasks") return;
    if (matterTasks) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (matterTasks[props?.matterId]) {
        props.onDataReceived.call(undefined, {
          data: matterTasks[props?.matterId]?.data,
          total: matterTasks[props?.matterId]?.total,
        });
        return;
      }
    }
    if (!matterTasks[props?.matterId] || props.updateFilter) {
      debouncedRequestDataIfNeeded();
    }
  }, [
    props?.updateFilter,
    matterTasks,
    props?.matterId,
    pending,
    props.dataState,
    lastSuccess,
    props.refresh,
    debouncedRequestDataIfNeeded,
  ]);

  // Work Done Activities - Clear cache on refresh
  React.useEffect(() => {
    if (props.currentComponent === "workDone") {
      lastSuccess.current = "";
    }
  }, [props.refresh, props.currentComponent]);

  // Work Done Activities
  React.useEffect(() => {
    if (props.currentComponent !== "workDone") {
      return;
    }
    if (workDoneActivities) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: workDoneActivities?.data || [],
          total: workDoneActivities?.total || 0,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    workDoneActivities,
    props?.updateFilter,
    props.dataState,
    props.branchId,
    props.teamId,
    props.feeEarnerRef,
    props.fD,
    props.tD,
    props.typeId,
    props.searchValue,
    props.refresh,
    lastSuccess,
    pending,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (
      props.currentComponent !== "chitPosting" &&
      props.currentComponent !== "chitAuthorization" &&
      props.currentComponent !== "batchPosting"
    ) {
      return;
    }
    lastSuccess.current = "";
    pending.current = "";
  }, [props.parameters, props.currentComponent]);

  React.useEffect(() => {
    if (props.currentComponent !== "chitPosting") return;
    if (chitPostingList) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: chitPostingList.data,
          total: chitPostingList.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    chitPostingList,
    pending,
    props.dataState,
    lastSuccess,
    props.refresh,
    props.parameters,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (props.currentComponent !== "chitAuthorization") return;
    if (chitPostingList) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: chitPostingList.data,
          total: chitPostingList.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    chitPostingList,
    pending,
    props.dataState,
    lastSuccess,
    props.refresh,
    props.parameters,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (props.currentComponent !== "billingRequests") return;
    if (billRequestsList) {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: billRequestsList.data,
          total: billRequestsList.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    billRequestsList,
    pending,
    props.dataState,
    lastSuccess,
    props.refresh,
    props.parameters,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (batchPostingList && props.currentComponent === "batchPosting") {
      lastSuccess.current = pending.current;
      pending.current = "";
      if (
        toODataString(props.dataState) === lastSuccess.current ||
        props.isSearched
      ) {
        props.onDataReceived.call(undefined, {
          data: batchPostingList.data,
          total: batchPostingList.total,
        });
        return;
      }
    }
    debouncedRequestDataIfNeeded();
  }, [
    batchPostingList,
    pending,
    props.dataState,
    lastSuccess,
    props.parameters,
    props.refresh,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (mattersPostings && props.currentComponent === "mattersLedger") {
      lastSuccess.current = pending.current;
      pending.current = "";

      if (
        toODataString(props.dataState) === lastSuccess.current ||
        props.isSearched
      ) {
        props.onDataReceived.call(undefined, {
          data: mattersPostings.data,
          total: mattersPostings.total,
        });
        return;
      }
    }
    if (
      !toODataString(props.dataState) === lastSuccess.current &&
      !props.isSearched
    ) {
      debouncedRequestDataIfNeeded();
    }
  }, [
    mattersPostings,
    pending,
    props.dataState,
    lastSuccess,
    props.isSearched,
    props.changed,
    props.searchValue,
    props.IncludeReversals,
    props.isRefreshed,
    debouncedRequestDataIfNeeded,
  ]);

  React.useEffect(() => {
    if (ctoSweepData && props.currentComponent === "ctoSweep") {
      lastSuccess.current = pending.current;
      pending.current = "";

      if (toODataString(props.dataState) === lastSuccess.current) {
        props.onDataReceived.call(undefined, {
          data: ctoSweepData.data,
          total: ctoSweepData.total,
        });
        return;
      }
    } else {
      debouncedRequestDataIfNeeded();
    }
  }, [
    ctoSweepData,
    pending,
    props.dataState,
    lastSuccess,
    debouncedRequestDataIfNeeded,
  ]);

  return pending.current && showLoader ? <LoadingPanel /> : null;
};
const LoadingPanel = () => {
  const loadingPanel = (
    <div className="k-loading-mask ">
      <span className="k-loading-text ">Loading</span>
      <div className="k-loading-image " />
      <div className="k-loading-color " />
    </div>
  );
  const gridContent =
    document && document.querySelector(".k-grid-content k-virtual-content");
  return gridContent
    ? ReactDOM.createPortal(loadingPanel, gridContent)
    : loadingPanel;
};
